import * as React from 'react';
import SecondaryMenu from '../shared/SecondaryMenu';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import SvgIcon from '@material-ui/core/SvgIcon';

import { getPasswordStrength, PasswordStrength } from '../../common/utility';
import { useState } from 'react';
import api from '../../store/api';
import { consts } from '../../common/consts'
import LinearProgress from '@material-ui/core/LinearProgress';
import Alert from '@material-ui/lab/Alert';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { useForm, Controller } from "react-hook-form";
import { TextField, FormHelperText, Typography } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { useHistory } from "react-router-dom";
import MenuItem from '@material-ui/core/MenuItem';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Checkbox from '@material-ui/core/Checkbox';
import Skeleton from '@material-ui/lab/Skeleton';
import { de } from 'date-fns/locale';

interface SelectItem extends React.Props<any> {
    text: string | undefined,
    value: string | undefined,
    selected: boolean,
    disabled: boolean | undefined
};

interface AddEditUserProps {
    userId: string | null
};
interface ProfilePermission {
    userProfilePermissionId: string,
    applicationPermissionId: string,
    userProfileId: string,
    createdBy: string,
    modifiedBy: string,
    applicationPermissionName: string,
    checked: boolean | null,
    isAdmin: boolean | null,
    scope: number | null,
    categoryId: string,
    categoryName: string,
    appPermissionRequireScope: boolean | null,
    appPermissionIsInternal: boolean | null,
    appPermDisplayName: string,
    appPermDescription: string,
    role: string,
    subName: string,
};
interface ProfileProps {
    userProfileId: string,
    name: string,
    createdOn: string,
    modifiedOn: string,
    createdBy: string,
    modifiedBy: string,
    deleted: boolean,
    customerLocationId: string,
    selected: boolean,
    idleTimeInMinutes: string,
    logOutTimeOutInMinutes: string,
    checked: boolean | null,
};

//#region styles
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    heading: {
        fontSize: 36,
        fontWeight: 900,
        padding: theme.spacing(0, 0, 2, 0)
    },
    margin: {
        margin: theme.spacing(1)
    },
    extendedIcon: {
        fontSize: 'small',
        color: theme.palette.primary.light,
    },
    main: {

    },
    mainGrid: {
        width: '100%',
        //padding: theme.spacing(0, 20, 0, 50)
        paddingLeft: 40,
        paddingRight: 40,
    },
    mainTop: {
        //padding: theme.spacing(5, 20, 0, 50)

        paddingRight: 40,
        paddingTop: 40,
    },
    textField: {
        backgroundColor: '#ECECEC',
        height: 30
    },
    textFieldLable: {
        fontSize: 15,
        color: '#949494',
        padding: theme.spacing(0, 0, 1, 0),
        fontWeight: 'bold',
    },
    selectField: {
        backgroundColor: '#ECECEC',
        height: 40
    },
    formBtn: {
        margin: theme.spacing(0, 1, 0, 1),
        width: '100px',
        height: '40px'
    },
    formLeft: {
        //margin: theme.spacing(0, 0, 0, 50)
        marginLeft: 40,
        marginBottom: 40,
        marginTop: 40,
    },
    loading: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paperModal: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2, 4, 3),
    },
    alertRoot: {
        marginTop: 24
    },
    headingAlert: {
        padding: theme.spacing(0, 0, 2, 0),
    },
    textFieldRoot: {
        width: '100%',
        fontWeight: 'bold',
    },
    textFieldInput: {
        backgroundColor: '#ECECEC',
        color: 'black',
        height: '40px'
    },
    helpText: {
        color: 'red',
        padding: theme.spacing(0, 0, 0, 2)
    },
    infoText: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        padding: theme.spacing(0, 0, 0, 2),
        color: "#02489D",
        cursor: "pointer"
    },
    profilePermissionCheckbox: {
        "& .Mui-disabled":
        {
            color: "#000"
        },
        "& .MuiSvgIcon-root":
        {
            color: "#000"
        },
        "& .MuiIconButton-label:after":
        {
            content:"none !important"
        }
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    removeHover: {
        backgroundColor: "transparent",
        "&:hover": {
            backgroundColor: "transparent"
        }
    },
    alertErrorRoot: {
        marginLeft: 40,
        marginRight: 40,
        marginBottom: 40,
        marginTop: 40
    },
    backBtn: {
        fontSize: 18,
        fontWeight: 700,
        color: "#02489D",
        position: "relative",
        top: -5,
    },
    dropdownIcon:{
        top:4
    },
    subPrivilegeList: {
        fontFamily: "'Lato', sans-serif",
        padding: "10px 0px",
        paddingLeft: "28px",
        '& .listSection': {
            padding: "10px 0px",
            '& .title': {
                fontSize: "15px",
                fontWeight: 400,
                color: "#949494",
                paddingBottom: "12px",
            },
            '& .body': {
                '& .list': {
                    '& .MuiFormControlLabel-root': {
                        margin: "0px",
                        '& .MuiCheckbox-root': {
                            padding: "2px",
                            paddingRight: "10px",
                        },
                        '& .MuiTypography-body1': {
                            fontSize: "15px",
                            fontWeight: 400,
                        },
                    },
                },
            },
        },
    },
}));
//#endregion

function AddEditUserWidget(props: AddEditUserProps): JSX.Element {
    const history = useHistory();
    //#region API calls and Functions
    const classes = useStyles();
    const userId = props.userId;

    const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError } = useForm();
    const { handleSubmit: handleSubmit_cg, watch: watch_cg, errors: errors_cg, control: control_cg, formState: formState_cg, setValue: setValue_cg, getValues: getValues_cg, setError: setError_cg } = useForm();

    let passwordWatch = watch('password');
    let cg_passwordWatch = watch_cg('cg_password');
    const [editUser, setEditUser] = useState(userId ? true : false);
    const [editUserId, setEditUserId] = useState(userId);
    const [headingText, setHeadingText] = useState('Users');
    const [mainHeadingText, setMainHeadingText] = useState(userId ? 'Edit User' : 'New User');
    const [errorMessagePassword, setErrorMessagePassword] = useState(false);
    const [inviteVisible, setInviteVisible] = useState(true);
    const [isEnabled, setIsEnabled] = useState(true);
    const [passwordVisible, setPasswordVisible] = useState(false);
    setValue('inviteUser', 'Yes');
    setValue('accountType', 'Personal Account');
    const [loading, setLoading] = useState(false);
    const [passwordStrength, setPasswordStrength] = useState<PasswordStrength>(PasswordStrength.none);
    const [resetpasswordStrength, setResetPasswordStrength] = useState<PasswordStrength>(PasswordStrength.none);
    const [customerList, setCustomerList] = useState<SelectItem[]>([]);
    const [locationList, setLocationList] = useState<SelectItem[]>([]);
    const [wardList, setWardList] = useState<SelectItem[]>([]);
    const [profileList, setProfileList] = useState<SelectItem[]>([]);
    const [open, setOpen] = useState(false);
    const [profileDialogOpen, setProfileDialogOpen] = useState(false);
    const [profilePermissionInfoLoaded, setProfilePermissionInfoLoaded] = useState(false);
    const [profileFeaturesList, setProfileFeaturesList] = useState<ProfilePermission[]>([]);

    const [showProfileInfo, setShowProfileInfo] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [statusMessage, setStatusMessage] = useState("");
    const [ enable2FA, setEnable2FA] = useState(false);
    const[show,setshow] =useState(false);
    const [isInternal, setIsInternal] = React.useState(true);
    const [profileListManageuser, setProfileListManageuser] = useState<ProfileProps[]>([]);
    React.useEffect(() => {
        setLoading(true);
        if (userId)
            getEditUserData();
        else
            getAddUserData();
    }, []);

    //separate call to get locations
    const getWardsPerLocations = async (locationId: string): Promise<void> => {
        setWardList([]);
        const _res = await api.getWardsInLocation('locationId=' + locationId);
        if (_res !== null && _res.data !== null && _res.data.model !== null) {
            setValue('wardId', '');
            setWardList(_res.data.model);
            setLoading(false);
            resetMessages();
        } else if (_res.data.errorRaised) {
            setLoading(false);
            resetMessages();
        }
    }

    const getLocationsPerCustomer = async (customerId: string): Promise<void> => {
        const _res = await api.getLocationsPerCustomer('customerId=' + customerId);
        if (_res !== null && _res.data !== null && _res.data.model !== null) {
            setLocationList(_res.data.model);
            setLoading(false);
            resetMessages();
        } else if (_res.data.errorRaised) {
            setLoading(false);
            resetMessages();
        }
    }

    const getUserprofilePerCustomer = async (customerId: string): Promise<void> => {
        //+ '&locationId=' + ''
        const _res = await api.getProfilesByLocation('customerId=' + customerId , '');

            if (_res !== null && _res.data !== null && _res.data.model !== null) {
                setProfileList(_res.data.model);
                setLoading(false);
                resetMessages();
            } else if (_res.data.errorRaised) {
                setLoading(false);
                resetMessages();
            }
    }

    const getProfilesPerLocation = async (locationId: string): Promise<void> => {
        try {
            const _res = await api.getProfilesByLocation(!locationId ? 'version='+Math.random()+Math.random()+Math.random() : 'locationId=' + locationId+'&version='+Math.random()+Math.random()+Math.random(), '');

            if (_res !== null && _res.data !== null && _res.data.model !== null) {
                setProfileList(_res.data.model);
                setLoading(false);
                resetMessages();
            } else if (_res.data.errorRaised) {
                setLoading(false);
                resetMessages();
            }
        }
        catch (error) {
            setLoading(false);
            setErrorMessage('Error when getting profiles');
            setProfileList([]);
        }
    }

    //call to get user data
    const getAddUserData = async (): Promise<void> => {
        try {
            const _res = await api.getAddUserData('');
            if (_res !== null && _res.data !== null && _res.data.model !== null) {
                setCustomerList(_res.data.model.customers);
                setLocationList(_res.data.model.locations);
                setProfileList(_res.data.model.profiles);
                setLoading(false);
                resetMessages();
            }
        }
        catch(error) {
            setLoading(false);
            setErrorMessage('Error when adding a new user');
            setProfileList([]);
            setLocationList([]);
        }
    }

    //call to get edit user data
    const getEditUserData = async (): Promise<void> => {
        try {          
            const _res = await api.getEditUserData('userId=' + editUserId+'&version='+Math.random()+Math.random()+Math.random());
            if (_res !== null && _res.data !== null && _res.data.model !== null) {
                setCustomerList(_res.data.model.customers);
                setLocationList(_res.data.model.locations);
                setProfileList(_res.data.model.profiles);
                setWardList(_res.data.model.wards);
                setHeadingText(_res.data.model.firstName + ' ' + _res.data.model.lastName);

                let fields = ['firstName', 'lastName', 'emailAddress', 'phoneNumber', 'customerId', 'locationId', 'wardId', 'isEnabled', 'employeeId', 'enable2FA', 'userProfileId'];
                for (let field in fields) {
                    let fieldName = fields[field];
                    if (fieldName == 'isEnabled') {
                        setIsEnabled(_res.data.model[fieldName]);
                    } if (fieldName == 'enable2FA') {
                        setEnable2FA(_res.data.model[fieldName] ?? false);
                    } else {                      
                        if (fieldName === "userProfileId" && _res.data.model[fieldName]) {                          
                            var profileslst =  _res.data.model.profiles;
                            if(profileList.length == 0){
                                setProfileList(profileslst);
                            }                                             
                            var checkprofiles =  profileslst.filter((x:any)=>x.value == _res.data.model[fieldName])  
                            if(checkprofiles.length === 0)
                            {
                                window.location.replace("/settings/users");
                            }                                           
                            setShowProfileInfo(true);
                        }  
                        if(_res.data.model[fieldName])
                        {
                            //selectChangedHandler(_res.data.model[fieldName],fieldName);
                            setValue(fieldName, _res.data.model[fieldName]);
                        }  
                    }
                }

                setLoading(false);
                resetMessages();
            }
        }
        catch (error) {
            setLoading(false);
            setErrorMessage('Error happened while trying to edit user');
        }
    }

    //call to generate password    
    const generatePassword = async (): Promise<void> => {
        setErrorMessage("");
        setStatusMessage("");
        await api.generatePassword('')
            .then(_res => {
                if (_res !== null && _res.data !== null && _res.data.password !== null) {
                    if (!open) {
                        setValue('password', _res.data.password);
                        setValue('confirmedPassword', _res.data.password);
                        setPasswordStrength(getPasswordStrength(_res.data.password));
                        updatePasswordStrengthLabel('main');
                    }
                    else {
                        setValue_cg('cg_password', _res.data.password);
                        setValue_cg('cg_confirmedPassword', _res.data.password);
                        setResetPasswordStrength(getPasswordStrength(_res.data.password));
                        updatePasswordStrengthLabel('edit');
                    }
                }
            })
            .catch(error => {
                setErrorMessage(error);
            });
    }

    //resend email link
    const resendEmailInvitation = async (): Promise<void> => {
        setErrorMessage("");
        setStatusMessage("");
        setLoading(true);
        if (!editUserId) {
            setStatusMessage('Error while finding userId');
        }

        let _req: { [index: string]: any } = { userId: editUserId };

        await api.resendInvitationLink('', _req)
            .then(res => {
                if (res.message !== null)
                    setStatusMessage(res.message);
                setLoading(false);
            })
            .catch(error => {
                setErrorMessage(error);
                setLoading(false);
            });
    }

    //resend email link
    const changePassword = async (): Promise<void> => {
        setErrorMessage("");
        setStatusMessage("");
        setLoading(true);
        let values = getValues_cg();
        if (!editUserId) {
            setStatusMessage('Error while finding userId');
        }
        let _req: { [index: string]: any } = { userId: editUserId, password: values['cg_password'] };
        await api.changePassword('', _req)
            .then(res => {
                if (!res.hasError) {
                    handleClose();
                }
                if (res.message !== null)
                    setStatusMessage(res.message);
                setLoading(false);
            })
            .catch(error => {
                setErrorMessage(error);
                setLoading(false);
            });
        setLoading(false);
    }

    //call to add a new user    
    const addNewUser = async (): Promise<void> => {
        setErrorMessage("");
        setStatusMessage("");
        setLoading(true);
        let values = getValues();
        let _req: { [index: string]: any } = {};
        if (passwordVisible) {
            _req = {
                firstName: values['firstName'],
                lastName: values['lastName'],
                phoneNumber: values["phoneNumber"].replaceAll(' ', '').replaceAll('-', ''),
                emailAddress: values['emailAddress'],
                employeeId: parseInt(values['employeeId']),
                password: values['password'],
                userProfileId: values['userProfileId'],
                locationId: values['locationId'] == '' ? null : values['locationId'],
                customerId: values['customerId'] == '' ? null : values['customerId'],
                wardId: values['wardId'] == '' ? null : values['wardId'],
                inviteUser: !passwordVisible,
                userName: values['emailAddress'],
                isSharedUser: !inviteVisible,
                isEnabled: isEnabled,
                enable2FA: enable2FA
            };
        } else {
            _req = {
                firstName: values['firstName'],
                lastName: values['lastName'],
                phoneNumber: values["phoneNumber"].replaceAll(' ', '').replaceAll('-', ''),
                emailAddress: values['emailAddress'],
                employeeId: parseInt(values['employeeId']),
                userProfileId: values['userProfileId'],
                locationId: values['locationId'] == '' ? null : values['locationId'],
                customerId: values['customerId'] == '' ? null : values['customerId'],
                wardId: values['wardId'] == '' ? null : values['wardId'],
                inviteUser: !passwordVisible,
                userName: values['emailAddress'],
                isSharedUser: !inviteVisible,
                isEnabled: isEnabled,
                enable2FA: enable2FA
            };
        }

        await api.addNewUser('', _req)
            .then(res => {
                if (!res.hasError && res.message !== null) {
                    setStatusMessage(res.message);
                    backToUserList();
                }
                else
                    setErrorMessage(res.message ?? "");
                setLoading(false);
            })
            .catch(error => {
                setErrorMessage(error);
                setLoading(false);
            });
    }

    const updateUser = async (): Promise<void> => {
        setErrorMessage("");
        setStatusMessage("");
        setLoading(true);
        let values = getValues();
        let _req: { [index: string]: any } = {
            userId: editUserId,
            firstName: values['firstName'],
            lastName: values['lastName'],
            phoneNumber: values["phoneNumber"].replaceAll(' ', '').replaceAll('-', ''),
            emailAddress: values['emailAddress'],
            employeeId: parseInt(values['employeeId']),
            userProfileId: values['userProfileId'],
            locationId: values['locationId'] == '' ? null : values['locationId'],
            customerId: values['customerId'] == '' ? null : values['customerId'],
            wardId: values['wardId'] == '' ? null : values['wardId'],
            isEnabled: isEnabled ? true : false,
            enable2FA: enable2FA
        };
        
        await api.updateUser('', _req)
            .then(res => {
                if (!res.hasError && res.message !== null)
                    setStatusMessage(res.message);
                else
                    setErrorMessage(res.message);
                setLoading(false);
            })
            .catch(error => {
                setErrorMessage(error);
                setLoading(false);
            });
    }

    //#endregion

    //#region Handle element state changes
    const selectChangedHandler = (value: any, filedName: string) => {
        let pickValue = value;

        if (filedName == 'customerId' && pickValue != '') {
            setValue('customerId', value);
            setLoading(true);
            getUserprofilePerCustomer(pickValue);
            getLocationsPerCustomer(pickValue);
            setValue('userProfileId', '');
            setValue('locationId', '');
            setValue('wardId', '');
            setWardList([]);
            setProfileList([]);
        } else if (filedName == 'customerId') {
            setValue('customerId', value);
            getUserprofilePerCustomer(pickValue);
            setValue('locationId', '');
            setValue('userProfileId', '');
            setValue('wardId', '');
            setLocationList([]);
            setWardList([]);
            setProfileList([]);
        }
        
        if (filedName == 'locationId' && pickValue != '') {
            setValue('locationId', value);
            setLoading(true);
            getWardsPerLocations(pickValue);      
        } else if(filedName == 'locationId' && pickValue == ''){
            setValue('locationId', value);
            if(value === "")
            {
                var customerid = getValues("customerId");
                if(customerid !== null)
                {
                    getUserprofilePerCustomer(customerid);
                }
                  setValue('wardId', '');
                setWardList([]);
            }          
        }else if (filedName == 'locationId') {
            setValue('locationId', value);              
        }

        if (filedName == 'wardId' && pickValue != '') {
            setValue('wardId', value);
        } else if (filedName == 'wardId') {
            setValue('wardId', value);
        }

        if (filedName == 'userProfileId' && pickValue != '') {
            setValue('userProfileId', value);
           
        } else if (filedName == 'userProfileId') {
            setValue('userProfileId', value);
        }
        
    }

    const handleOpen = () => {
        setOpen(true);
        resetMessages();
    };

    const handleClose = () => {
        setOpen(false);
        setResetPasswordStrength(PasswordStrength.none);
        updatePasswordStrengthLabel('edit');
        resetMessages();
    };

    const backToUserList = () => {
        history.push({
            pathname: '/settings/users'
        });
    };

    const updatePasswordStrengthLabel = (type: string) => {
        let fontColor = 'red';
        if (passwordStrength === PasswordStrength.moderate || resetpasswordStrength === PasswordStrength.moderate) {
            fontColor = 'orange';
        }
        if (passwordStrength === PasswordStrength.good || resetpasswordStrength === PasswordStrength.good) {
            fontColor = 'green';
        }
        return (
            type == 'main' ?
                <label style={{ color: fontColor }}> {passwordStrength} </label >
                :
                <label style={{ color: fontColor }}> {resetpasswordStrength} </label >
        )
    }

    const resetMessages = () => {
        setErrorMessage('');
        setStatusMessage('');
    }

    //#endregion

    //#region Other Components
    const StarIcon = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" style={{ marginRight: 5 }}>
                <path id="_copy" data-name="* copy" d="M7.961,10,9.444,8.9,7.056,5.658,11,4.306,10.276,2.6,6.4,4.021V0H4.487V4.021L.651,2.6,0,4.306,3.836,5.658,1.484,8.9,3.112,10,5.464,6.584Z" fill="#f4b827" />
            </svg>
        );
    }

    const ArrowIcon = (props: any) => {
        return (
            <SvgIcon style={{ height: 30, width: 30 }}>
                <path d="M6.293,13.707l-6-6L.257,7.67h0L.242,7.652.235,7.644.226,7.634.217,7.622.212,7.615.2,7.6l0,0L.186,7.581l0,0L.172,7.56l0,0L.158,7.54l0,0L.146,7.52l0,0L.134,7.5l0-.005L.122,7.48l0-.008L.112,7.46.106,7.449l0-.009L.094,7.424l0,0L.083,7.4h0a1,1,0,0,1,0-.8v0l.008-.017,0-.009L.1,6.562l.007-.014,0-.006a1,1,0,0,1,.182-.25l6-6A1,1,0,0,1,7.707,1.707L3.414,6H17a1,1,0,0,1,0,2H3.414l4.293,4.293a1,1,0,1,1-1.414,1.414Z" fill="#02489D" />
            </SvgIcon>
        );
    }

    const HorizontalLine = (props: any) => {
        return (
            <hr
                style={{
                    height: 0,
                    borderTop: '1px solid #979797',
                }}
            />
        )
    }

    const GeneratePassword = (type: string): JSX.Element => {
        return (
            <div className="rowC">
                <div className="hintText">Password Strength:<span className="hintPassword">{updatePasswordStrengthLabel(type)}</span></div>
                <div className="rightAlignContainer">
                    <Button className="passwordBtn" color="primary" onClick={generatePassword}>Generate Password</Button>
                </div>
            </div>
        )
    }

    const ResendLink = () => {
        return (
            <div className="rightAlignContainer">
                <Button className="resendBtn" color="primary" onClick={resendEmailInvitation}>Resend Invitation Link</Button>
            </div>
        )
    }

    const CreateLoadingLine = (props: any): JSX.Element => {
        return (
            <div className={classes.loading}>
                <LinearProgress color="primary" />
            </div>
        )
    }
    //Main Form Passwords
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const [showConfirmedPassword, setShowConfirmedPassword] = useState(false);
    const handleClickShowConfirmedPassword = () => {
        setShowConfirmedPassword(!showConfirmedPassword);
    };
    const handleMouseDownConfirmedPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    //Edit User Form Passwords
    const [cg_showPassword, cg_setShowPassword] = useState(false);
    const cg_handleClickShowPassword = () => {
        cg_setShowPassword(!cg_showPassword);
    };
    const cg_handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const [cg_showConfirmedPassword, cg_setShowConfirmedPassword] = useState(false);
    const cg_handleClickShowConfirmedPassword = () => {
        cg_setShowConfirmedPassword(!cg_showConfirmedPassword);
    };
    const cg_handleMouseDownConfirmedPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };
    const getProfilesManageuser = (locationId: any,profileId:any): void => {
        
        let dataModal = {
            locationId: locationId == "SMA" ? null : locationId,
            userProfileId:profileId
        };

        let profileList: ProfileProps[] = [];
        api.getUsermanageuser('profileId=' + profileId+'&version='+Math.random()+Math.random()+Math.random())
            .then(res => {
                setProfileListManageuser([]);
                if (res !== null && res.data !== null && res.data.model !== null) {                   
                    profileList = res.data.model;
                    setProfileListManageuser(profileList);
                }
            })
            .catch(error => {
                setProfileList([]);
                setErrorMessage('Error while getting profiles: ' + error);
            });
     
    }
    const handleProfileInfoClick = () => {
        setProfileDialogOpen(true);
        if (!profilePermissionInfoLoaded) {
            let values = getValues();
            api.getProfileAllowedPermissions('profileId=' + values["userProfileId"]+'&version='+Math.random()+Math.random()+Math.random())
                .then(res => {
                    if (res !== null && res.data !== null && res.data.model !== null) {
                        let _permsList: ProfilePermission[] = res.data.model;
                        if (_permsList !== null) {

                            setProfileFeaturesList(_permsList);
                           
                            console.log(_permsList);
                            _permsList.filter(p => p.applicationPermissionName ==="SMAScheduleTransfer" || p.applicationPermissionName === "ScheduleTransfer").map((x:any, i) =>{                    
                            var val = x.checked;
                            
                            if(val === true)
                            {
                                setshow(true);
                                resetMessages();
                            }                    
                            return;
                        }                       
                        )

                        }
                        else {
                            setProfileFeaturesList([]);
                        }
                        setProfilePermissionInfoLoaded(true);
                    }
                })
                .catch(error => {
                    alert("An error occured while loading profile");
                });
                getProfilesManageuser(values["locationId"],values["userProfileId"]);  
        }
    };
    const handleUserProfileDialogClose = () => {
        setProfileDialogOpen(false);
    }
    //body color header
    const Heading = ({ text, color }: any) => {
        return (
            <div style={{ color: color, fontWeight: 900, fontSize: 18 }}>{text}</div>
        )
    }
    //body feature description
    const Description = ({ text }: any) => {
        return (
            <div style={{ color: '#7D7D7D', fontSize: 14, paddingLeft: 28 }}>{text}</div>
        )
    }
    const getSelectedProfileName = () => {
        let values = getValues();
        let selectedProfile = profileList.find(p => p.value === values["userProfileId"]);
        if (selectedProfile) {
            return selectedProfile.text;
        }
        else {
            return null;
        }
    }
    //#endregion
    const validateUserProfile = async (value: string): Promise<boolean | string> => {
        let values = getValues();
        if (value === "None" || value === "") {
            return "User Profile is required";
        } 
        else if((values.locationId ===null)||(values.locationId ==="")){
            return true;
        }
        else {
            if (values["wardId"]) {
                return true;
            }
            else {
                let _permsList: ProfilePermission[] = [];
                if (!profilePermissionInfoLoaded) {
                    let res = await api.getProfileAllowedPermissions('profileId=' + value+'&version='+Math.random()+Math.random()+Math.random());
                    if (res !== null && res.data !== null && res.data.model !== null) {
                        _permsList = res.data.model;
                        if (_permsList !== null) {

                            setProfileFeaturesList(_permsList);

                        }
                        else {
                            setProfileFeaturesList([]);
                        }
                        setProfilePermissionInfoLoaded(true);
                    }
                }
                else {
                    _permsList = profileFeaturesList;
                }
                if (_permsList.filter(p => p.appPermissionRequireScope && p.scope === 1).length == 0) {
                    return true;
                }
                return true
                // else {
                //         setError("wardId", {
                //         type: "validate",
                //         message: "The user profile selected requires a ward to be selected"                   
                //         })
                //         return true;
                // }
            }   
        }      
    }
    const validateWard = async (value: string): Promise<boolean | string> => {
        let values = getValues();
        
        if (value && value !== "None") {
            return true;
        }
        else if((values.locationId ===null)||(values.locationId ==="")){
            return true;
        }
        else {
            if (!values["userProfileId"] || values["userProfileId"] === "None") {
                return true;
            }
            let _permsList: ProfilePermission[] = [];
            if (!profilePermissionInfoLoaded) {
                let res = await api.getProfileAllowedPermissions('profileId=' + values["userProfileId"]+'&version='+Math.random()+Math.random()+Math.random());
                if (res !== null && res.data !== null && res.data.model !== null) {
                    _permsList = res.data.model;
                    if (_permsList !== null) {

                        setProfileFeaturesList(_permsList);

                    }
                    else {
                        setProfileFeaturesList([]);
                    }
                    setProfilePermissionInfoLoaded(true);
                }
            }
            else {
                _permsList = profileFeaturesList;
            }
         
            if (_permsList.filter(p => p.appPermissionRequireScope && p.scope === 1).length == 0) {
                return true;
            }
            return true
            // else {
            //     return "The user profile selected requires a ward to be selected";                     
            // }
        }
    }
  
    return (
        <React.Fragment>

            <Dialog open={open} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="sm">
                <DialogTitle id="form-dialog-title">Change Password</DialogTitle>
                <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <form onSubmit={handleSubmit_cg(changePassword)} autoComplete="off" id="changePasswordForm">
                    <DialogContent>
                        <div>
                            <div className={classes.textFieldLable}><span><StarIcon /></span>PASSWORD</div>
                            <Controller
                                defaultValue=''
                                control={control_cg}
                                render={({ onChange, onBlur, value, name }) => (<TextField classes={{ root: classes.textFieldRoot }} InputProps={{
                                    classes: {
                                        root: classes.textFieldInput
                                    },
                                    endAdornment: <InputAdornment position="end">
                                        <IconButton style={{ color: '#000' }}
                                            aria-label="toggle password visibility"
                                            onClick={cg_handleClickShowPassword}
                                            onMouseDown={cg_handleMouseDownPassword}>
                                            {cg_showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                }}
                                    onBlur={onBlur}
                                    value={value}
                                    name={name}
                                    onChange={e => {
                                        let pwdStrength = getPasswordStrength(e.target.value);
                                        setResetPasswordStrength(pwdStrength);
                                        onChange(e)
                                    }}
                                    variant='outlined' type={cg_showPassword ? 'text' : 'password'} error={errors_cg.cg_password} helperText={errors_cg.cg_password ? errors_cg.cg_password.message : ""} />)}
                                name='cg_password'
                                rules={{
                                    required: "Password is required",
                                    validate: (value) => {
                                        let pwdStrength = getPasswordStrength(value);
                                        if (pwdStrength !== PasswordStrength.good) {
                                            setErrorMessagePassword(true);
                                            return false;
                                        }
                                        else {
                                            setErrorMessagePassword(false);
                                            return true;
                                        }
                                    }
                                }}
                            />
                        </div>
                        {GeneratePassword('edit')}
                        <div>
                            <div className={classes.textFieldLable}><span><StarIcon /></span>CONFIRMED PASSWORD</div>
                            <Controller
                                defaultValue=''
                                control={control_cg}
                                as={<TextField classes={{ root: classes.textFieldRoot }} InputProps={{
                                    classes: {
                                        root: classes.textFieldInput
                                    },
                                    endAdornment: <InputAdornment position="end">
                                        <IconButton style={{ color: '#000' }}
                                            aria-label="toggle password visibility"
                                            onClick={cg_handleClickShowConfirmedPassword}
                                            onMouseDown={cg_handleMouseDownConfirmedPassword}>
                                            {cg_showConfirmedPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                }} variant='outlined' type={cg_showConfirmedPassword ? 'text' : 'password'} error={errors_cg.cg_confirmedPassword} helperText={errors_cg.cg_confirmedPassword ? errors_cg.cg_confirmedPassword.message : ""} />}
                                name='cg_confirmedPassword'
                                rules={{
                                    required: "Confirmed Password is required",
                                    validate: (value) => {
                                        if (cg_passwordWatch === value) {
                                            return true;
                                        }
                                        else {
                                            return "Confirmed Password does not match"
                                        }
                                    }
                                }}
                            />
                        </div>
                    </DialogContent>

                    {
                        errorMessagePassword ?
                            <div>
                                <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" className={classes.alertErrorRoot} >
                                    Please enter a stronger password to continue. Try making your password longer, adding special characters (!@#$%^^&*), adding numbers and using upper case letters.
                                                    </Alert>
                            </div>
                            : null
                    }

                    <DialogActions>
                        <div className="divModalBtn">
                            <Button className="modalBtn" variant="contained" onClick={handleClose}>Cancel</Button>
                            <Button className="modalBtn" variant="contained" color="primary" disabled={formState_cg.isSubmitting} type='submit'>Save</Button>
                        </div>
                    </DialogActions>
                </form>
            </Dialog>

            <div style={{ display: 'flex', alignItems: 'stretch', flexGrow: 1, }}>
                <div>
                    <form style={{ display: 'flex', height: '100%' }} onSubmit={handleSubmit(editUser ? updateUser : addNewUser)} autoComplete="off" id="addUserForm">

                        <div style={{ height: '100%', display: 'flex', }}>
                            <SecondaryMenu selectedmenu="Users" />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>

                            <div style={{ width: '100%', }}>
                                <div>



                                    <Grid className={classes.mainGrid} container spacing={3}>
                                        <Grid item xs={12}>
                                            <div className={classes.mainTop}>
                                                <IconButton className={classes.removeHover} onClick={backToUserList} aria-label="delete" size="small">
                                                    <ArrowIcon fontSize="large" /><Typography className={classes.backBtn}>{headingText}</Typography>
                                                </IconButton>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <div className={classes.main}>
                                                <div className={classes.heading}>
                                                    {mainHeadingText}
                                                </div>
                                            </div>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <div className={classes.textFieldLable}><span><StarIcon /></span>FIRST NAME</div>
                                            <Controller
                                                control={control}
                                                as={<TextField classes={{ root: classes.textFieldRoot }} InputProps={{ classes: { root: classes.textFieldInput } }} variant='outlined'
                                                    error={errors.firstName}
                                                    helperText={errors.firstName ? errors.firstName.message : ""} />}
                                                name='firstName'
                                                defaultValue=''
                                                rules={{
                                                    required: "First Name is required",
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={3}>
                                            <div className={classes.textFieldLable}>LAST NAME</div>
                                            <Controller
                                                control={control}
                                                as={<TextField classes={{ root: classes.textFieldRoot }} InputProps={{ classes: { root: classes.textFieldInput } }} variant='outlined'
                                                    error={errors.lastName}
                                                    helperText={errors.lastName ? errors.lastName.message : ""} />}
                                                name='lastName'
                                                defaultValue=''
                                            />
                                        </Grid>

                                        <Grid item xs={6}>
                                            <div className={classes.textFieldLable}><span><StarIcon /></span>EMAIL ADDRESS</div>
                                            <Controller
                                                control={control}
                                                as={<TextField classes={{ root: classes.textFieldRoot }} InputProps={{ classes: { root: classes.textFieldInput } }} variant='outlined'
                                                    error={errors.emailAddress}
                                                    helperText={errors.emailAddress ? errors.emailAddress.message : ""} />}
                                                name='emailAddress'
                                                defaultValue=''
                                                rules={{
                                                    required: "Email Address is required",
                                                    pattern: {
                                                        value: consts.EmailRegex,
                                                        message: "Invalid email address"
                                                    }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <div className={classes.textFieldLable}>EMPLOYEE ID</div>
                                            <Controller
                                                control={control}
                                                as={<TextField
                                                    classes={{ root: classes.textFieldRoot }}
                                                    InputProps={{ classes: { root: classes.textFieldInput } }}
                                                    variant='outlined'
                                                    error={errors.employeeId} 
                                                    type="number"
                                                    />
                                                  }
                                                name='employeeId'
                                                defaultValue=''
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <div className={classes.textFieldLable}>CUSTOMER</div>
                                            <Controller
                                                name='customerId'
                                                defaultValue=''
                                                control={control}
                                                render={({ onChange, onBlur, value, name }) => (
                                                    <Select
                                                        error={errors.customerId}
                                                        onChange={e => selectChangedHandler(e.target.value, 'customerId')}
                                                        className={classes.selectField}
                                                        displayEmpty
                                                        IconComponent={KeyboardArrowDownIcon}
                                                        defaultValue=''
                                                        fullWidth={true}
                                                        value={value}
                                                        variant="outlined">
                                                        <MenuItem key="None" value={''}>None</MenuItem >
                                                        {
                                                            editUser ?
                                                                customerList.filter(c => c.disabled == false || c.value == value).map(item => <MenuItem disabled={item.disabled} selected={item.selected} key={item.value} defaultValue={item.value}
                                                                    value={item.value}>{item.text}</MenuItem>)
                                                                :
                                                                customerList.filter(c => c.disabled == false).map(item => <MenuItem selected={item.selected} key={item.value} defaultValue={item.value}
                                                                    value={item.value}>{item.text}</MenuItem>)
                                                        }
                                                    </Select>
                                                )}
                                            />
                                        </Grid>
                                        

                                        <Grid item xs={6}>
                                            <div className={classes.textFieldLable}><span><StarIcon /></span>MOBILE PHONE</div>
                                            <Controller
                                                control={control}
                                                as={<TextField
                                                    classes={{ root: classes.textFieldRoot }}
                                                    InputProps={{ classes: { root: classes.textFieldInput } }}
                                                    variant='outlined'
                                                    error={errors.phoneNumber}
                                                    helperText={errors.phoneNumber ? errors.phoneNumber.message : ""} />}
                                                name='phoneNumber'
                                                defaultValue=''
                                                rules={{
                                                    required: "Phone Number is required",
                                                    pattern: {
                                                        value: /^[0-9\s\-]{5,20}$/,
                                                        message: "Invalid phone number"
                                                    }
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={6}>
                                            <div className={classes.textFieldLable}>LOCATION</div>
                                            <Controller
                                                name='locationId'
                                                defaultValue=''
                                                control={control}
                                                render={({ onChange, onBlur, value, name }) => (
                                                    <Select
                                                        error={errors.locationId}
                                                        onChange={e => selectChangedHandler(e.target.value, 'locationId')}
                                                        className={classes.selectField}
                                                        fullWidth={true}
                                                        displayEmpty
                                                        defaultValue=''
                                                        classes={{icon:classes.dropdownIcon}}
                                                        IconComponent={KeyboardArrowDownIcon}
                                                        value={value}
                                                        variant="outlined">
                                                        <MenuItem key="None" value={''}>None</MenuItem >
                                                        {
                                                            editUser ?
                                                                locationList.filter(c => c.disabled == false || c.value == value).map(item => <MenuItem disabled={item.disabled} selected={item.selected}
                                                                    key={item.value} defaultValue={item.value} value={item.value}>{item.text}</MenuItem>)
                                                                :
                                                                locationList.filter(l => l.disabled == false).map(item => <MenuItem disabled={item.disabled} selected={item.selected}
                                                                    key={item.value} defaultValue={item.value} value={item.value}>{item.text}</MenuItem>)
                                                        }
                                                    </Select>
                                                )}
                                                // rules={{
                                                   
                                                //     validate: (value: string) => {
                                                //         let values = getValues();
                                                //         if (values["customerId"]) {
                                                //             if (!value) {
                                                //                 return "Location is required if customer is selected";
                                                //             }
                                                //         }
                                                //         return true;
                                                //     }
                                                // }}
                                            />
                                            <FormHelperText className={classes.helpText}>{errors.locationId ? errors.locationId.message : ''}</FormHelperText>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <div className={classes.textFieldLable}><span><StarIcon /></span>USER PROFILE</div>
                                            <Controller
                                                name='userProfileId'
                                                defaultValue=''
                                                control={control}
                                                render={({ onChange, onBlur, value, name }) => (
                                                    <div>
                                                        <Select
                                                            error={errors.userProfileId}
                                                            IconComponent={KeyboardArrowDownIcon}
                                                            onChange={e => {
                                                                let values = getValues();
                                                                if (e.target.value) {
                                                                    setShowProfileInfo(true);
                                                                    setProfilePermissionInfoLoaded(values["userProfileId"] === e.target.value);

                                                                }
                                                                else {
                                                                    setShowProfileInfo(false);
                                                                    setProfileDialogOpen(false);
                                                                    setProfilePermissionInfoLoaded(false);
                                                                }

                                                                selectChangedHandler(e.target.value, 'userProfileId');

                                                                onChange(e)
                                                            }}
                                                            className={classes.selectField}
                                                            value={value}
                                                            displayEmpty
                                                            defaultValue=''
                                                            fullWidth={true}
                                                            variant="outlined">
                                                            <MenuItem key="None" value={''}>Choose User Profile</MenuItem >
                                                            if (profileList !== undefined && profileList !== null)
                                                            {
                                                                profileList.map(item => <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>{item.text}</MenuItem >)
                                                            }
                                                        </Select>
                                                        {showProfileInfo ?
                                                            <FormHelperText className={classes.infoText} onClick={handleProfileInfoClick}><InfoOutlinedIcon fontSize="small" style={{ paddingRight: 5 }} />About this profile</FormHelperText>
                                                            : null}
                                                        <FormHelperText className={classes.helpText}>{errors.userProfileId ? errors.userProfileId.message : ''}</FormHelperText>
                                                        <Dialog onClose={handleUserProfileDialogClose} maxWidth="md" fullWidth open={profileDialogOpen}>
                                                            <DialogTitle id="profile-dialog-title">
                                                                User Privileges - {getSelectedProfileName()}
                                                            </DialogTitle>
                                                            <IconButton
                                                                aria-label="close"
                                                                className={classes.closeButton}
                                                                onClick={handleUserProfileDialogClose}
                                                            >
                                                                <CloseIcon />
                                                            </IconButton>
                                                            <DialogContent dividers>

                                                                {
                                                                    profilePermissionInfoLoaded ?
                                                                        <React.Fragment>
                                                                            {profileFeaturesList.filter(p => p.categoryName === "Admin Features").length > 0 ?
                                                                                <div style={{ borderLeft: '4px solid #577C6D', paddingLeft: 20, marginTop: 30 }}>
                                                                                    <Heading text="ADMIN FEATURES" color="#577C6D" />
                                                                                    {profileFeaturesList.filter(p => p.categoryName === "Admin Features"&& p.role !=="ManageUsers").map((perm, i) =>
                                                                                        <div key={perm.applicationPermissionId}>
                                                                                            <FormControlLabel
                                                                                                className={classes.profilePermissionCheckbox}
                                                                                                control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                label={perm.appPermDisplayName}
                                                                                            />
                                                                                            <Description text={perm.appPermDescription} />
                                                                                            {
                                                                                                perm.appPermissionRequireScope ?
                                                                                                    <div style={{ paddingLeft: 28 }}>
                                                                                                        <label>{perm.scope == 1 ? "For user's ward only" : "For any ward in hospital"}</label>
                                                                                                    </div> : null
                                                                                            }
                                                                                            {
                                                                                                perm.applicationPermissionName === "SMAAdminManageUsers" || perm.applicationPermissionName === "ManageUsers"  ?                                                                   
                                                                                                profileFeaturesList.filter(p => p.categoryName === "Admin Features" && p.role ==="ManageUsers").map((perms, i) =>                                            
                                                                                                <div style={{ paddingLeft: 28 }}>
                                                                                                        <label>{perms.scope == 2 ? "Having any user profile" : "Having selected user profiles"}</label>
                                                                                                    </div>                                                              
                                                                                                )
                                                                                                : null
                                                                                            }
                                                                                          
                                                                                            {
                                                                                  (perm.applicationPermissionName === "SMAAdminManageUsers" ||perm.applicationPermissionName === "ManageUsers") && (profileListManageuser !== undefined) ?     
                                                                                       profileListManageuser.map((perms, i) =>    
                                                                                        <div className={"body"}>
                                                                                        <div className={"list"} style={{marginLeft:"31px"}}>                                                                             
                                                                                            <FormControlLabel
                                                                                                className={classes.profilePermissionCheckbox}
                                                                                                control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                label={perms.name}
                                                                                            />
                                                                                        </div>
                                                                                        </div>
                                                                                            )
                                                                                        :null
                                                                                        }
                                                                                        </div>
                                                                                    )}

                                                                                </div> : null}
                                                                            {profileFeaturesList.filter(p => p.categoryName === "Patient Transport Features").length > 0 ?
                                                                                <div style={{ borderLeft: '4px solid #AE72C0', paddingLeft: 20, marginTop: 30 }}>
                                                                                    <Heading text="PATIENT TRANSPORT FEATURES" color="#AE72C0" />

                                                                                    {profileFeaturesList.filter(p => p.categoryName === "Patient Transport Features").map((perm, i) =>
                                                                                        <div key={perm.applicationPermissionId}>
                                                                                            {perm.role === null ?
                                                                                            <div> 
                                                                                            <FormControlLabel
                                                                                                className={classes.profilePermissionCheckbox}
                                                                                                control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                label={perm.appPermDisplayName}
                                                                                            />
                                                                                            <Description text={perm.appPermDescription} />
                                                                                            {
                                                                                                perm.appPermissionRequireScope ?
                                                                                                    <div style={{ paddingLeft: 28 }}>
                                                                                                        <label>{perm.scope == 1 ? "For user's ward only" : "For any ward in hospital"}</label>
                                                                                                    </div> : null
                                                                                            }
                                                                                            </div>
                                                                                            :null}
                                                                                            {/* //ScheduleTransfer */}
                                                                                     {(perm.applicationPermissionName =="SMAScheduleTransfer" ||perm.applicationPermissionName =="ScheduleTransfer") ?
                                                                                        <div className={classes.subPrivilegeList}>
                                                                                            <div className={"listSection"}>
                                                                                            {profileFeaturesList.filter(p => p.role ==="Primary").length>0?
                                                                                            <div className={"title"}>
                                                                                                    ACCESS PRIMARY PLANNERS
                                                                                                </div>
                                                                                                :null
                                                                                            }
                                                                                            {profileFeaturesList.filter(p => p.role ==="Primary").map((permp, i) =>  (<>
                                                                                                
                                                                                                <div className={"body"}>
                                                                                                    <div className={"list"}>
                                                                                                    <FormControlLabel
                                                                                                    className={classes.profilePermissionCheckbox}
                                                                                                    control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                    label={permp.appPermDisplayName}
                                                                                                         />
                                                                                                    </div>
                                                                                
                                                                                                </div>
                                                                                                </>))}
                                                                                            </div>
                                                                                            <div className={"listSection"}>
                                                                                            {profileFeaturesList.filter(p => p.role ==="Secondary").length>0  ?
                                                                                            <div className={"title"}>
                                                                                                    ACCESS SECONDARY PLANNERS
                                                                                                </div>
                                                                                                :null}
                                                                                            {profileFeaturesList.filter(p => p.role ==="Secondary").map((perms, i) =>  (<>
                                                                                                
                                                                                                <div className={"body"}>
                                                                                                    <div className={"list"}>
                                                                                                    <FormControlLabel
                                                                                                    className={classes.profilePermissionCheckbox}
                                                                                                    control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                    label={perms.appPermDisplayName}
                                                                                                         />                                   
                                                                                                    </div>
                                                                                                
                                                                                                </div>
                                                                                                </>))}
                                                                                            </div>                 
                                                                                        </div>
                                                                                        :null}
                                                                                        </div>
                                                                                    )}

                                                                                </div> : null}
                                                                                
                                              
                                          
                                                                            {profileFeaturesList.filter(p => p.categoryName === "Security").length > 0 ?
                                                                                <div style={{ borderLeft: '4px solid #B75959', paddingLeft: 20, marginTop: 30 }}>
                                                                                    <Heading text="SECURITY" color="#B75959" />

                                                                                    {profileFeaturesList.filter(p => p.categoryName === "Security").map((perm, i) =>
                                                                                        <div key={perm.applicationPermissionId}>
                                                                                            <FormControlLabel
                                                                                                className={classes.profilePermissionCheckbox}
                                                                                                control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                label={perm.appPermDisplayName}
                                                                                            />
                                                                                            <Description text={perm.appPermDescription} />
                                                                                            {
                                                                                                perm.appPermissionRequireScope ?
                                                                                                    <div style={{ paddingLeft: 28 }}>
                                                                                                        <label>{perm.scope == 1 ? "For user's ward only" : "For any ward in hospital"}</label>
                                                                                                    </div> : null
                                                                                            }
                                                                                        </div>
                                                                                    )}

                                                                                </div> : null}                                                                               
                                                                            {profileFeaturesList.filter(p => p.categoryName === "Medical Response").length > 0 ?
                                                                                <div style={{ borderLeft: '4px solid #AE72C0', paddingLeft: 20, marginTop: 30 }}>
                                                                                    <Heading text="MEDICAL RESPONSE" color="#AE72C0" />

                                                                                    {profileFeaturesList.filter(p => p.categoryName === "Medical Response").map((perm, i) =>
                                                                                        <div key={perm.applicationPermissionId}>
                                                                                            <FormControlLabel
                                                                                                className={classes.profilePermissionCheckbox}
                                                                                                control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                label={perm.appPermDisplayName}
                                                                                            />
                                                                                            <Description text={perm.appPermDescription} />
                                                                                            {
                                                                                                perm.appPermissionRequireScope ?
                                                                                                    <div style={{ paddingLeft: 28 }}>
                                                                                                        <label>{perm.scope == 1 ? "For user's ward only" : "For any ward in hospital"}</label>
                                                                                                    </div> : null
                                                                                            }
                                                                                        </div>
                                                                                    )}
                                                                                </div> : null}
                                                                                {profileFeaturesList.filter(p => p.categoryName === "PCR").length > 0 ?
                                                                                <div style={{ borderLeft: '4px solid #AE72C0', paddingLeft: 20, marginTop: 30 }}>
                                                                                    <Heading text="PCR" color="#AE72C0" />

                                                                                    {profileFeaturesList.filter(p => p.categoryName === "PCR" && p.role === "ViewPCR" && p.appPermissionIsInternal === true).map((perm, i) =>
                                                                                        <div key={perm.applicationPermissionId}>
                                                                                             {perm.applicationPermissionName ==="SMAViewPCR" &&(<>
                                                                                            <FormControlLabel
                                                                                                className={classes.profilePermissionCheckbox}
                                                                                                control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                label={perm.appPermDisplayName}
                                                                                            />
                                                                                            <Description text={perm.appPermDescription} />
                                                                                            {
                                                                                                perm.appPermissionRequireScope ?
                                                                                                    <div style={{ paddingLeft: 28 }}>
                                                                                                        <label>{perm.scope == 1 ? "For user's ward only" : "For any ward in hospital"}</label>
                                                                                                    </div> : null
                                                                                            }
                                                                                            </>)}
                                                                                            {perm.subName ==="ViewPCR"&& perm.applicationPermissionName ==="SMAReviewPCR"  &&(<>
                                                                                                
                                                                                                <div className={"body"}>
                                                                                                    <div className={"list"}>
                                                                                                    <FormControlLabel
                                                                                                    className={classes.profilePermissionCheckbox}
                                                                                                    control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                    label={perm.appPermDisplayName}
                                                                                                         />
                                                                                                    </div>
                                                                                
                                                                                                </div>
                                                                                                </>)}
                                                                                                {perm.subName ==="ReviewPCR"&& perm.applicationPermissionName ==="SMACGReviewPCR"  &&(<>
                                                                                                
                                                                                                <div className={"body"}>
                                                                                                    <div className={"list"}>
                                                                                                    <FormControlLabel
                                                                                                    className={classes.profilePermissionCheckbox}
                                                                                                    control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                    label={perm.appPermDisplayName}
                                                                                                         />
                                                                                                    </div>
                                                                                
                                                                                                </div>
                                                                                                </>)}
                                                                                               
                                                                                        </div>
                                                                                    )}
                                                                                     {profileFeaturesList.filter(p => p.categoryName === "PCR" && p.role === "ViewPCR" && p.appPermissionIsInternal === false).map((perm, i) =>
                                                                                        <div key={perm.applicationPermissionId}>
                                                                                             {perm.applicationPermissionName ==="ViewPCR" &&(<>
                                                                                            <FormControlLabel
                                                                                                className={classes.profilePermissionCheckbox}
                                                                                                control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                label={perm.appPermDisplayName}
                                                                                            />
                                                                                            <Description text={perm.appPermDescription} />
                                                                                            {
                                                                                                perm.appPermissionRequireScope ?
                                                                                                    <div style={{ paddingLeft: 28 }}>
                                                                                                        <label>{perm.scope == 1 ? "For user's ward only" : "For any ward in hospital"}</label>
                                                                                                    </div> : null
                                                                                            }
                                                                                            </>)}
                                                                                            {perm.subName ==="ViewPCR" && perm.applicationPermissionName ==="ReviewPCR" &&(<>
                                                                                                
                                                                                                <div className={"body"}>
                                                                                                    <div className={"list"}>
                                                                                                    <FormControlLabel
                                                                                                    className={classes.profilePermissionCheckbox}
                                                                                                    control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                    label={perm.applicationPermissionName}
                                                                                                         />
                                                                                                    </div>
                                                                                
                                                                                                </div>
                                                                                                </>)}
                                                                                                {perm.subName ==="ReviewPCR" && perm.applicationPermissionName ==="CGReviewPCR" &&(<>
                                                                                                
                                                                                                <div className={"body"}>
                                                                                                    <div className={"list"}>
                                                                                                    <FormControlLabel
                                                                                                    className={classes.profilePermissionCheckbox}
                                                                                                    control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                    label={perm.appPermDisplayName}
                                                                                                         />
                                                                                                    </div>
                                                                                
                                                                                                </div>
                                                                                                </>)}
                                                                                               
                                                                                        </div>
                                                                                    )}
                                                                                    {profileFeaturesList.filter(p => p.categoryName === "PCR" && p.role !== "ViewPCR").map((perm, i) =>
                                                                                        <div key={perm.applicationPermissionId}>
                                                                                            <FormControlLabel
                                                                                                className={classes.profilePermissionCheckbox}
                                                                                                control={<Checkbox
                                                                                                    style={{ padding: 4 }}
                                                                                                    checked={true}
                                                                                                    disabled />}
                                                                                                label={perm.appPermDisplayName}
                                                                                            />
                                                                                            <Description text={perm.appPermDescription} />
                                                                                            {
                                                                                                perm.appPermissionRequireScope ?
                                                                                                    <div style={{ paddingLeft: 28 }}>
                                                                                                        <label>{perm.scope == 1 ? "For user's ward only" : "For any ward in hospital"}</label>
                                                                                                    </div> : null
                                                                                            }                                                                                                                                                                  
                                                                                        </div>
                                                                                    )}
                                                                                </div> : null}
                                                                        </React.Fragment>

                                                                        : (
                                                                            <React.Fragment>
                                                                                <Skeleton variant="rect" width="100%" height={118} />
                                                                                <Skeleton variant="text" />
                                                                                <Skeleton variant="rect" width="100%" height={118} />
                                                                                <Skeleton variant="text" />
                                                                                <Skeleton variant="rect" width="100%" height={118} />
                                                                            </React.Fragment>
                                                                        )
                                                                }
                                                            </DialogContent>
                                                            <DialogActions>
                                                                <Button variant="contained" fullWidth onClick={handleUserProfileDialogClose} color="primary">
                                                                    Done
                                               </Button>
                                                            </DialogActions>
                                                        </Dialog>
                                                    </div>
                                                )}
                                                rules={{
                                                    required: "User profile is required",
                                                    validate: validateUserProfile
                                                }}
                                            />
                                        </Grid>
                                        

                                        <Grid item xs={6}>
                                            <div className={classes.textFieldLable}>WARD</div>
                                            <Controller
                                                name='wardId'
                                                defaultValue=''
                                                control={control}
                                                render={({ onChange, onBlur, value, name }) => (
                                                    <Select
                                                        error={errors.wardId}
                                                        onChange={e => selectChangedHandler(e.target.value, 'wardId')}
                                                        className={classes.selectField}
                                                        fullWidth={true}
                                                        value={value}
                                                        IconComponent={KeyboardArrowDownIcon}
                                                        displayEmpty
                                                        defaultValue=''
                                                        classes={{icon:classes.dropdownIcon}}
                                                        variant="outlined">
                                                        <MenuItem key="None" value={''}>None</MenuItem >
                                                        {
                                                            wardList.map(item => <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>{item.text}</MenuItem>)
                                                        }
                                                    </Select>
                                                )}
                                                rules={{
                                                    
                                                    validate: validateWard
                                                }}
                                            />
                                            <FormHelperText className={classes.helpText}>{errors.wardId ? errors.wardId.message : ''}</FormHelperText>
                                        </Grid>
                                        <Grid item xs={6}>
                                            {
                                                passwordVisible ?
                                                    (editUser ? null :
                                                        <div>
                                                            <div className={classes.textFieldLable}><span><StarIcon /></span>PASSWORD</div>
                                                            <Controller
                                                                defaultValue=''
                                                                control={control}
                                                                render={({ onChange, onBlur, value, name }) => (<TextField classes={{ root: classes.textFieldRoot }} InputProps={{
                                                                    classes: {
                                                                        root: classes.textFieldInput
                                                                    },
                                                                    endAdornment: <InputAdornment position="end">
                                                                        <IconButton style={{ color: '#000' }}
                                                                            aria-label="toggle password visibility"
                                                                            onClick={handleClickShowPassword}
                                                                            onMouseDown={handleMouseDownPassword}>
                                                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                }}
                                                                    onBlur={onBlur}
                                                                    value={value}
                                                                    name={name}
                                                                    onChange={e => {
                                                                        let pwdStrength = getPasswordStrength(e.target.value);
                                                                        setPasswordStrength(pwdStrength);
                                                                        onChange(e)
                                                                    }}
                                                                    variant='outlined' type={showPassword ? 'text' : 'password'} error={errors.password} helperText={errors.password ? errors.password.message : ""} />)}
                                                                name='password'
                                                                rules={!editUser ? {
                                                                    required: "Password is required",
                                                                    validate: (value) => {
                                                                        let pwdStrength = getPasswordStrength(value);
                                                                        if (pwdStrength !== PasswordStrength.good) {
                                                                            setErrorMessage("Please enter a stronger password to continue. Try making your password longer, adding special characters (!@#$%^^&*), adding numbers and using upper case letters.");
                                                                            return false;
                                                                        }
                                                                        else {
                                                                            setErrorMessage("");
                                                                            return true;
                                                                        }
                                                                    }
                                                                } : {}}
                                                            />
                                                        </div>
                                                    ) : null
                                            }
                                            {passwordVisible ? (editUser ? null : GeneratePassword('main')) : null}
                                        </Grid>

                                        <Grid item xs={6}>
                                            {
                                                passwordVisible ?
                                                    (editUser ? null :
                                                        <div>
                                                            <div className={classes.textFieldLable}><span><StarIcon /></span>CONFIRMED PASSWORD</div>
                                                            <Controller
                                                                defaultValue=''
                                                                control={control}
                                                                as={<TextField classes={{ root: classes.textFieldRoot }} InputProps={{
                                                                    classes: {
                                                                        root: classes.textFieldInput
                                                                    },
                                                                    endAdornment: <InputAdornment position="end">
                                                                        <IconButton style={{ color: '#000' }}
                                                                            aria-label="toggle password visibility"
                                                                            onClick={handleClickShowConfirmedPassword}
                                                                            onMouseDown={handleMouseDownConfirmedPassword}>
                                                                            {showConfirmedPassword ? <Visibility /> : <VisibilityOff />}
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                }} variant='outlined' type={showConfirmedPassword ? 'text' : 'password'} error={errors.confirmedPassword} helperText={errors.confirmedPassword ? errors.confirmedPassword.message : ""} />}
                                                                name='confirmedPassword'
                                                                rules={!editUser ? {
                                                                    required: "Confirmed Password is required",
                                                                    validate: (value) => {
                                                                        console.log(value);
                                                                        if (passwordWatch === value) {
                                                                            return true;
                                                                        }
                                                                        else {
                                                                            return "Confirmed Password does not match"
                                                                        }
                                                                    }
                                                                } : {}}
                                                            />
                                                        </div>
                                                    ) : null
                                            }
                                        </Grid>

                                        <Grid item xs={6}>
                                            {inviteVisible ?
                                                (editUser ? null :
                                                    <div>
                                                        <div>
                                                            <div className={classes.textFieldLable}><span><StarIcon /></span>INVITE USER (VIA EMAIL ABOVE) TO SIGN UP?</div>
                                                            <Controller
                                                                render={(props) => (
                                                                    <RadioGroup row aria-label="position" name="inviteUser" defaultValue="top">
                                                                        <FormControlLabel
                                                                            value='Yes'
                                                                            onChange={e => {
                                                                                setPasswordVisible(false);
                                                                                props.onChange(e)
                                                                            }}
                                                                            checked={!passwordVisible}
                                                                            control={<Radio color="primary" />}
                                                                            label='Yes' />
                                                                        <FormControlLabel
                                                                            value='No'
                                                                            onChange={e => {
                                                                                setPasswordVisible(true);
                                                                                props.onChange(e)
                                                                            }}
                                                                            checked={passwordVisible}
                                                                            control={<Radio color="primary" />}
                                                                            label='No' />
                                                                    </RadioGroup>
                                                                )}
                                                                name="inviteUser"
                                                                control={control}
                                                                defaultValue=''
                                                                rules={!editUser ? {
                                                                    required: "Invite option is required",
                                                                } : {}}
                                                            />
                                                        </div>
                                                        <div>
                                                            <FormHelperText className={classes.helpText}>{errors.inviteUser ? errors.inviteUser.message : ''}</FormHelperText>
                                                            <div className="hintText" style={{ fontSize: 14 }}>They’ll be able to confirm their email address and phone number and choose their own password</div>
                                                        </div>

                                                    </div>
                                                )
                                                : null}
                                            {editUser ? <ResendLink /> : null}
                                        </Grid>
                                         <Grid item xs={6} /> 
                                        <Grid item xs={6}>
                                            <div>
                                                <div className={classes.textFieldLable}>USER STATUS</div>
                                                <Controller
                                                    render={(props) => (
                                                        <RadioGroup row aria-label="position" name="isEnabled" defaultValue="top">
                                                            <FormControlLabel
                                                                value='Enabled'
                                                                checked={isEnabled}
                                                                onChange={e => {
                                                                    setIsEnabled(true);
                                                                    props.onChange(e)
                                                                }}
                                                                control={<Radio color="primary" />}
                                                                label='Enabled' />
                                                            <FormControlLabel
                                                                value='Disabled'
                                                                checked={!isEnabled}
                                                                onChange={e => {
                                                                    setIsEnabled(false);
                                                                    props.onChange(e)
                                                                }}
                                                                control={<Radio color="primary" />}
                                                                label='Disabled' />
                                                        </RadioGroup>
                                                    )}
                                                    defaultValue=''
                                                    name="isEnabled"
                                                    control={control}
                                                />
                                            </div>
                                        </Grid>
                                        
                                        <Grid item xs={6}>
                                            <div>
                                                <div className={classes.textFieldLable}>ENABLE 2FA</div>
                                                <Controller
                                                    render={(props) => (
                                                        <RadioGroup row aria-label="position" name="enable2FA" defaultValue="top">
                                                            <FormControlLabel
                                                                value='Enabled'
                                                                checked={enable2FA}
                                                                onChange={e => {
                                                                    setEnable2FA(true);
                                                                    props.onChange(e);
                                                                }}
                                                                control={<Radio color="primary" />}
                                                                label='Enabled' />
                                                            <FormControlLabel
                                                                value='Disabled'
                                                                checked={!enable2FA}
                                                                onChange={e => {
                                                                    setEnable2FA(false);
                                                                    props.onChange(e);
                                                                }}
                                                                control={<Radio color="primary" />}
                                                                label='Disabled' />
                                                        </RadioGroup>
                                                    )}
                                                    defaultValue=''
                                                    name="enable2FA"
                                                    control={control}
                                                />
                                            </div>
                                        </Grid>
                                        <Grid item xs={4}>
                                            {!editUser ?
                                                <div>
                                                    <div className={classes.textFieldLable}>ACCOUNT TYPE</div>
                                                    <Controller
                                                        render={(props) => (
                                                            <RadioGroup row aria-label="position" name="accountType" defaultValue="top">
                                                                <FormControlLabel
                                                                    value='Shared Account'
                                                                    onChange={e => {
                                                                        setInviteVisible(false);
                                                                        setPasswordVisible(true);
                                                                        props.onChange(e)
                                                                    }}
                                                                    checked={!inviteVisible}
                                                                    control={<Radio color="primary" />}
                                                                    label='Shared Account' />
                                                                <FormControlLabel
                                                                    value='Personal Account'
                                                                    onChange={e => {
                                                                        setInviteVisible(true);
                                                                        setPasswordVisible(false);
                                                                        props.onChange(e)
                                                                    }}
                                                                    checked={inviteVisible}
                                                                    control={<Radio color="primary" />}
                                                                    label='Personal Account' />
                                                            </RadioGroup>
                                                        )}
                                                        defaultValue=''
                                                        name="accountType"
                                                        control={control}
                                                    />
                                                </div>
                                                : null
                                            }
                                        </Grid>

                                    </Grid>

                                    <div className={classes.main} style={{ paddingLeft: 40, paddingRight: 40, }}>
                                        <div className={classes.headingAlert}>
                                            <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" classes={{ root: classes.alertRoot }} style={{ display: errorMessage ? 'flex' : 'none' }}>
                                                {errorMessage}
                                            </Alert>
                                            <Alert variant="filled" severity="success" classes={{ root: classes.alertRoot }} style={{ display: statusMessage ? 'flex' : 'none' }}>
                                                {statusMessage}
                                            </Alert>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div>
                                <div>
                                    {loading ? <CreateLoadingLine /> : <HorizontalLine />}
                                </div>

                                <div className={classes.formLeft}>
                                    <Button disabled={formState.isSubmitting} className={classes.formBtn} variant="contained" color="primary" type='submit'>Save</Button>
                                    <Button className={classes.formBtn} variant="contained" onClick={backToUserList}>Cancel</Button>
                                    {editUser ? <Button className="changePasswordBtn" variant="contained" onClick={handleOpen}>Change Password</Button> : null}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

        </React.Fragment>
    )
}
export default React.memo(AddEditUserWidget);